module.exports = import("https://cdn.jsdelivr.net/npm/@undecaf/zbar-wasm@0.9.16/dist/main.js");;